import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Modal } from 'ui'
import LayoutAccountStatement from './components/LayoutAccountStatement'
import { AccountStatementProvider } from './context/AccountStatementContext'
import { TittleBanner } from './components/TittleBanner'
import { AccountToSendForm } from './components/AccountToSendForm'
import AccountStatementPanel from './components/AccountStatementPanel'

function Configuration() {
   const intl = useIntl()
   const [isTryOnModalOpen, setIsTryOnModalOpen] = React.useState(false)
   const [isEmailModalOpen, setIsEmailModalOpen] = React.useState(false)
   const [active, setActive] = useState("Escritorio");

   return (
      <>
         <AccountStatementProvider>
            <TittleBanner
               setIsTryOnModalOpen={setIsTryOnModalOpen}
               setIsEmailModalOpen={setIsEmailModalOpen}
            />
            <AccountStatementPanel />
            <AccountToSendForm
               isEmailModalOpen={isEmailModalOpen}
               setIsEmailModalOpen={setIsEmailModalOpen}
            />
            <Modal visible={isTryOnModalOpen}
               onClose={() => setIsTryOnModalOpen(false)} {...(active === 'Móvil' && { size: "md" })} >
               <Modal.Header>
                  <h2 className="px-4 text-lg text-gray-600 font-bold"> {intl.formatMessage({ id: `settings.tryon` })}</h2>
                  <div className="inline-flex bg-gray-200 rounded-lg p-1">
                     {["Escritorio", "Móvil"].map((option) => (
                        <button
                           key={option}
                           onClick={() => setActive(option)}
                           className={`px-4 py-2 text-sm font-semibold rounded-md transition-all ${active === option ? "bg-white shadow text-gray-900" : "text-gray-500"
                              }`}
                        >
                           {option}
                        </button>
                     ))}
                  </div>

               </Modal.Header>
               <Modal.Body className='p-8'>
                  <LayoutAccountStatement />
               </Modal.Body>
            </Modal>
         </AccountStatementProvider>
      </>
   )
}

export default Configuration